import { motion } from "framer-motion";
import { useEffect, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const sectionFade = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

export default function PaymentMethods() {
  const { t, isRTL } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <section
      dir={isRTL ? "rtl" : "ltr"}
      className="relative overflow-hidden bg-gradient-to-b from-rose-50/50 via-white to-white py-24"
    >
      <div className="mx-auto max-w-4xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-20 text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            {t("paymentMethods.title")}
          </h1>
          <p className="mt-4 text-gray-600">
            {t("paymentMethods.subtitle")}
          </p>
        </motion.div>

        {/* Content */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="space-y-10"
        >

          {["cards", "transfers", "agencies", "crypto", "billing"].map(
            (key) => (
              <motion.div key={key} variants={sectionFade} className="legal-card">
                <h2 className="legal-title">
                  {t(`paymentMethods.sections.${key}.title`)}
                </h2>

                <ul className="list-disc pl-6 space-y-2">
                  {t(`paymentMethods.sections.${key}.items`, {
                    returnObjects: true,
                  }).map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>

                {t(`paymentMethods.sections.${key}.note`, {
                  defaultValue: "",
                }) && (
                  <p className="mt-4">
                    {t(`paymentMethods.sections.${key}.note`)}
                  </p>
                )}
              </motion.div>
            )
          )}

          {/* Security */}
          <motion.div variants={sectionFade} className="legal-card">
            <h2 className="legal-title">
              {t("paymentMethods.sections.security.title")}
            </h2>
            <p>{t("paymentMethods.sections.security.text")}</p>
          </motion.div>

          {/* Help */}
          <motion.div variants={sectionFade} className="legal-card">
            <h2 className="legal-title">
              {t("paymentMethods.sections.help.title")}
            </h2>
            <p>
              {t("paymentMethods.sections.help.text")}{" "}
              <a
                href="mailto:Billing@teqa.app"
                className="text-rose-600 hover:underline"
              >
                {t("paymentMethods.sections.help.email")}
              </a>
            </p>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
}
